import { useQuery, gql } from '@apollo/client';
import { VirtualAccountDailySnapshotFilterType, VirtualAccountDailySnapshotType } from '../types/VirtualAccountDailySnapshotFilterType';

// GraphQL查询定义
const VIRTUAL_ACCOUNT_DAILY_SNAPSHOT_QUERY = gql`
    query GetVirtualAccountDailySnapshots(
        $filters: VirtualAccountDailySnapshotFilterTypeInput,
        $pageRequest: PageRequestTypeInput
    ) {
        getVirtualAccountDailySnapshots(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                clientId
                clientName
                accountId
                virtualAccountNo
                accountType
                balance
                overdraftLimit
                currency
                clientTimezone
                snapshotDate
                snapshotTime
                createdAt
                updatedAt
            }
            totalElements
            totalPages
            size
            page
        }
    }
`;

export const useVirtualAccountDailySnapshotQuery = (
    filters: VirtualAccountDailySnapshotFilterType,
    currentPage: number,
    pageSize: number
) => {
    const { data, loading, error, refetch } = useQuery(VIRTUAL_ACCOUNT_DAILY_SNAPSHOT_QUERY, {
        variables: {
            filters: {
                clientId: filters.clientId,
                snapshotDateFrom: filters.snapshotDateFrom,
                snapshotDateTo: filters.snapshotDateTo,
                accountType: filters.accountType
            },
            pageRequest: {
                page: currentPage, // 后端PageRequestType从1开始
                size: pageSize
            }
        },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    const snapshotData: VirtualAccountDailySnapshotType[] = 
        data?.getVirtualAccountDailySnapshots?.content || [];
    
    const totalElements: number = 
        data?.getVirtualAccountDailySnapshots?.totalElements || 0;

    return {
        snapshotData,
        loading,
        error,
        refetch,
        totalElements,
        buildQueryVariables: () => ({
            filters: {
                clientId: filters.clientId,
                snapshotDateFrom: filters.snapshotDateFrom,
                snapshotDateTo: filters.snapshotDateTo,
                accountType: filters.accountType
            },
            pageRequest: {
                page: currentPage,
                size: pageSize
            }
        })
    };
};